import { render, staticRenderFns } from "./status-up.vue?vue&type=template&id=5276b556&"
import script from "./status-up.vue?vue&type=script&lang=js&"
export * from "./status-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5276b556')) {
      api.createRecord('5276b556', component.options)
    } else {
      api.reload('5276b556', component.options)
    }
    module.hot.accept("./status-up.vue?vue&type=template&id=5276b556&", function () {
      api.rerender('5276b556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/status-up.vue"
export default component.exports